import axios from "axios";

const pincodeCheckService = (pincode:string) => {
    return axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
};

export default pincodeCheckService;